import React from "react";
import { useIntl } from "react-intl";
import moment from "moment";
import { Typography, Space } from "antd";
const { Text } = Typography;

const FeedItemText = ({ messageId, content }) => {
  const intl = useIntl();
  return (
    <div className="feedItem" style={{ width: "130px" }}>
      <Text type="secondary">{intl.formatMessage({ id: messageId })}</Text>
      <Text>{content}</Text>
    </div>
  );
};

const FeedItemContent = ({ record }) => {
  const { task, event } = record;
  const body = task?.body || event?.body;
  const type = task?.type || "event";
  const start_time = event?.start_time;
  const end_time = event?.end_time;
  const ownerName = event?.owner.name || task?.owner.name;
  const updtaedBy =
    record?.task?.updated_by?.name || record?.event?.updated_by?.name;
  return (
    <div className="feedItemWrapper">
      {body && (
        <div className="feedItem">
          <FeedItemText
            messageId={
              type === "event"
                ? "app.forms.event.body"
                : type === "mail"
                ? "app.forms.mail.body"
                : "app.forms.log.body"
            }
            content={body}
          />
        </div>
      )}
      {type === "event" && (
        <div className="feedItem">
          <Space size="middle">
            <FeedItemText
              messageId="app.forms.event.start_time"
              content={moment(start_time).format("HH:mm DD/MM/YYYY")}
            />
            <FeedItemText
              messageId="app.forms.event.end_time"
              content={moment(end_time).format("HH:mm DD/MM/YYYY")}
            />
          </Space>
        </div>
      )}
      <div>
        <Space size="middle">
          <FeedItemText
            messageId="app.activities.creation_date"
            content={moment(record.date).format("l")}
          />
          <FeedItemText
            messageId="app.activities.creator"
            content={ownerName}
          />
          {updtaedBy && (
            <FeedItemText
              messageId="app.activities.updated_by"
              content={updtaedBy}
            />
          )}
          {record?.task?.task_type && (
            <FeedItemText
              messageId="app.activities.task_type"
              content={record?.task?.task_type?.name}
            />
          )}
          {record?.task?.sub_task_type && (
            <FeedItemText
              messageId="app.activities.sub_task_type"
              content={record?.task?.sub_task_type?.name}
            />
          )}
        </Space>
      </div>
    </div>
  );
};
export default FeedItemContent;
